import { createSlice } from '@reduxjs/toolkit';
import { IWorkOrderGridState, IInitAction, IInitResolveAction } from './types';

const initialState: IWorkOrderGridState = {
  userId: undefined,
  gridData: [],
};

const slice = createSlice({
  name: 'agsWorkOrderGrid',
  initialState,
  reducers: {
    init: (state, action: IInitAction) => {
      const { payload: { userId } = {} } = action;
      state.userId = userId;
    },
    initResolve: (state, action: IInitResolveAction) => {
      const { payload: { workOrder: responseData } = {} } = action;
      if (responseData && responseData.Body && responseData.Body.WorkOrders) {
        state.gridData = responseData.Body.WorkOrders;
      }
    },
  },
});

export const { actions, reducer } = slice;
export default slice.reducer;
